<div class="container-fluid h-100 readOnlyForm pl-0 pr-0">
  <!-- <div id="snackbar">{{toastMsg}}</div> -->
  <!-- Section header start -->
  <div class="headerBackground card p-1 mb-2 tool-header-height">
    <div class="row padding2px">
      <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 sectionHeaderIcon">
        <span>
          <!-- <fa-icon class="fas checklistIcon"   [icon]="faCircle">
          </fa-icon> -->
          <fa-icon class="fas fa-lg autoCursor" title="click for smart checklist" (click)="openSmartChecklist()"
            [icon]="faSkiing"></fa-icon>
        </span>
      </div>
      <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-4">
        <h6 class="headerFontSize cursorArrow">{{ 'menu.deepdive' | translate }}</h6>
      </div>
      <div class="col col-6 col-md-6 col-lg-6 col-sm-6 col-xs-6 cursorArrow">
        <p class="titleParagraph">{{'deepDive.toolHeaderLine1' | translate}}<br>
          {{'deepDive.toolHeaderLine2' | translate}}
        </p>
      </div>
      <!-- <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1">
          <div class="dropGroupBtn marginbottom5px">
            <span>
              <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkDD">
                <i class="fas fa-info-circle"></i>
              </a>
            </span>
          </div>
          <div class="dropGroupBtn marginbottom5px">
            <span>
              <i class="fas fa-file-export" [ngClass]="{ dis:deepDive.model.EUTdetails.length ==0}"
                (click)="modelData.entityName && goToView();modelData.generateReport()"></i>
            </span>
          </div>
        </div> -->

      <div class="col col-2 col-md-2 col-lg-2 col-sm-2 col-xs-2">
        <table class="dropGroupBtn">
          <tr>
            <td rowspan="2">
              <span>
                <a type="button" (click)="selectedEntityIDDetails && generateMindMap()">
                  <fa-icon class="fas fa-lg" [icon]="faSitemap" title="mindmap"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" (click)="selectedEntityIDDetails && openChatGPTassist()">
                  <fa-icon class="fas fa-lg toolLogoYellow" [icon]="faLightbulb" title="intelligent assistant"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span>
                <a type="button" data-toggle="modal" data-target="#ytVideoLinkDD">
                  <fa-icon class="fas fa-lg" [icon]="faInfoCircle" title="help"></fa-icon>
                </a>
              </span>
            </td>
            <td rowspan="2">
              <span (click)="entityName && generateReport('true')">
                <fa-icon class="fas fa-lg cursorPointer" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td rowspan="2">
              <span class="autoCursor cursorPointer">
                <fa-icon class="fas fa-lg extraIcon" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
          </tr>
        </table>
        <!-- <table class="dropGroupBtn">
          <tr>
            <td class="iconGroupHeight">
              <span>
                <a type="button" class="" data-toggle="modal" data-target="#ytVideoLinkDD">
                  <fa-icon class="fas" [icon]="faInfo"></fa-icon>
                </a>
              </span>
            </td>
            <td>
            </td>
          </tr>
          <tr class="bg-color-black">
            <td class="height25px">
              <span (click)="entityName && generateReport('true')">
                <fa-icon class="fas" [icon]="faFileExport" title="report"></fa-icon>
              </span>
            </td>
            <td>
              <span>
                <fa-icon class="fas" [icon]="faJira" [ngClass]="{ dis:jiraInterfaceDisabled}" (click)="loadBugList()">
                </fa-icon>
              </span>
            </td>
          </tr>
        </table> -->
      </div>
    </div>
  </div>
  <!-- Section header end -->
  <div class="deep-dive tool-body-height">
    <div class="card p-1 mb-2 bg-white h-100">
      <div class="row full-width p-0">
        <div class="col-sm-2 col-xs-3 btn-padding">
          <div class="row strict radio-button">
            <div class="dropdown">
              <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                type="button" data-toggle="dropdown">
                <div class="row strict">
                  <div class="col-xs-10">
                    <span *ngIf="selectedModule!=''">{{selectedModule.mName}}
                    </span>
                    <span *ngIf="selectedModule==''">{{'deepDive.chooseEUT' | translate }}</span>
                  </div>
                  <div class="col-xs-1 col-xs-offset-1 pull-right ">
                    <span class="caret"></span>
                  </div>
                </div>
              </button>
              <ul class="dropdown-menu deepDriveEntityDropdown">
                <li class="row strict" *ngFor="let module of modelData.modules">
                  <div class="col-xs-11 col-xs-offset-1  dropdown-item cursorPointer" (click)="selectModule(module)">
                    {{module.mName}}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-sm-10 col-xs-9 btn-padding ">
          <div class="dropdown">
            <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
              type="button" data-toggle="dropdown">
              <div class="row strict">
                <div class="col-xs-10 span-on-button ">
                  {{entityName||'deepDive.chooseEntityButton' | translate }}
                </div>
                <div class="col-xs-1 col-xs-offset-1 pull-right ">
                  <span class="caret"></span>
                </div>
              </div>
              <!-- <div *ngIf="!modelData.entityExists(modelData.eutTypes[modelData.index])">
                  <strong>No
                    {{modelData.getEntityType(modelData.eutTypes[modelData.index]) | lowercase}}
                    defined.</strong>
                </div> -->
            </button>

            <ul class="dropdown-menu fit-size">
              <li *ngIf="entitiesExists() == false">
                <div class="alert alert-warning cursorArrow">
                  <strong>No
                    entities
                    defined.
                  </strong>
                </div>
              </li>
              <div class="row" *ngIf="entitiesExists() == true">
                <div class="col-xs-12">
                  <div class="input-group input-group-sm">
                    <input type="text" class="form-control search-add-on" [(ngModel)]="searchText"
                      [placeholder]="'entities.searchEntity' | translate ">
                    <span class="input-group-addon " id="basic-addon2">
                      <fa-icon class="fas icon-black" [icon]="faSearch"></fa-icon>
                    </span>
                  </div>
                </div>
              </div>
              <li
                *ngFor="let eut of modelData.listOfEUTs|moduleEntityListFilter:selectedModule:filterTypeList:searchText"
                (click)="loadEntityDetails(eut)">
                <a class="dropdown-item">({{getScenarioCountByeutID(eut)}}) {{eut.eType}} | {{eut.eName}}</a>
              </li>
            </ul>
          </div>
        </div>

        <!-- <div class="col-sm-2 col-xs-5 btn-padding paddingright0px paddingleft0px">
                  <div class="row strict" ng-if='selectedEUT == "TT"'>
                    <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                      <div>
                        <button type="button"
                          ng-class="{ dis:showText==true || plusBtnEnabled==false}"
                          (click)="selectedCheckList(true,true,'')"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-plus menuItemsClrBlack paddingtop3px paddingbottom3px"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                      <div>
                        <button type="button"
                          ng-class="{ dis:showText==true || actionBtnsEnabled==false}"
                          (click)="editCheckListName(checklistName)"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-edit menuItemsClrBlack paddingtop3px paddingbottom3px"></i>
                        </button>
                      </div>
                    </div>
                    <div class="col-xs-3 col-xs-offset-1 col-sm-3 col-sm-offset-1">
                      <div *ngIf="!showText">
                        <button type="button" data-toggle="modal" data-target="#checklistDeleteConfirmModel1"
                          ng-class="{ dis:showText==true || actionBtnsEnabled==false}"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-trash menuItemsClrBlack paddingtop3px paddingbottom3px"></i>
                        </button>
                      </div>
                      <div *ngIf="showText">
                        <button type="button" (click)="clear()"
                          class="btn btn-default btn-block btn-sm padding3px">
                          <i class="fa fa-times menuItemsClrBlack"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div> -->
      </div>
      <div class="row strict">
        <ul class="nav nav-tabs">
          <li class="active">
            <a data-toggle="tab" id="designerActiveTab" class="textClrWhite" (click)="changeTab('specs')"
              ng-attr-data-target="#specsTab">{{'deepDive.specsTab' | translate }}</a>
          </li>
          <li (click)="changeTab('notes')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#notesTab">{{'deepDive.notesTab' | translate
              }}</a>
          </li>
          <li (click)="changeTab('maps')">
            <a data-toggle="tab" class="textClrWhite" ng-attr-data-target="#mapsTab">{{'deepDive.mapsTab' | translate
              }}</a>
          </li>
        </ul>
      </div>
      <div class="tab-content test-designer-nav-tab-content-height card">
        <!-- <div class="test-designer-fieldset-section-height pb-3"> -->
        <div ng-attr-id="notesTab" *ngIf="currentTab == 'notes'" class="tab-pane fade active in h-100">
          <div class="row strict h-90 card bg-white borderWhite">
            <div id="executorQuillCSS" class="test-designer-quill-content-height">
              <quill-editor (onEditorChanged)="editorChanged($event)" (onBlur)="blur($event)"
                [(ngModel)]="selectedEntityNotes.notes">
                <div quill-editor-toolbar>
                  <span class="ql-formats">
                    <select class="ql-header"></select>
                    <button class="ql-bold" [title]="'Bold'"></button>
                    <button class="ql-italic" [title]="'Italic'"></button>
                    <button class="ql-underline" [title]="'Underline'"></button>
                    <button class="ql-list" value="ordered"></button>
                    <button class="ql-list" value="bullet"></button>
                    <!-- <button class="ql-image" [title]="'Image'"></button>
                    <button class="ql-code" [title]="'Code'"></button> -->
                  </span>
                </div>
              </quill-editor>
            </div>
          </div>
          <!-- <div class="h-90">
            <fieldset class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
              <legend class="scheduler-border">{{ 'deepDive.ddNotesHeader' | translate }} </legend>
              <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off" data-html="true"
                role="button" data-toggle="popover" data-placement="left"
                [title]="'deepDive.ddNotesHeaderTip' | translate">
              </div>
              <div class="control-group fieldset-text-box-height paddingtop7px">
                <div class="row strict h-100">
                  <div class="col-xs-12 h-100">
                    <textarea class="form-control transparent square-edge bg-color-black h-100"
                      [(ngModel)]="entityDesc" rows="1" id="sample-notes" (focusout)="updateEntityDetails()"
                      [placeholder]="'deepDive.ddNotesHeaderPlaceholder'|translate"></textarea>
                  </div>
                </div>
              </div>
            </fieldset>
          </div> -->
        </div>
        <div ng-attr-id="specsTab" *ngIf="currentTab == 'specs'" class="tab-pane fade active in h-100">
          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddBcHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddBcHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea class="form-control transparent square-edge bg-color-black h-100"
                        [ngClass]="{ dis:!selectedEntity.eID}" [(ngModel)]="selectedEntity.bc" rows="1" id="BC"
                        (focusout)="updateEntityDetails('bc')"
                        [placeholder]="'deepDive.ddBcHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <div class="h-100">
                <fieldset
                  class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                  <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddAcHeader' | translate }}</legend>
                  <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                    data-html="true" role="button" data-toggle="popover" data-placement="left"
                    [title]="'deepDive.ddAcHeaderTip' | translate">
                  </div>
                  <div class="control-group fieldset-text-box-height paddingtop7px">
                    <div class="row strict h-100">
                      <div class="col-xs-12 h-100">
                        <textarea id="AC" rows="1" [ngClass]="{ dis:!selectedEntity.eID}" [(ngModel)]="selectedEntity.ac"
                          (focusout)="updateEntityDetails('ac')"
                          class=" form-control transparent square-edge bg-color-black h-100"
                          [placeholder]="'deepDive.ddAcHeaderPlaceholder'|translate"></textarea>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>
          </div>

          <div class="row padding-vertical h-50">
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddOutcomeHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddOutcomeHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="outcomes" rows="1" [ngClass]="{ dis:!selectedEntity.eID}" [(ngModel)]="selectedEntity.outcomes"
                        (focusout)="updateEntityDetails('oc')"
                        class=" form-control transparent square-edge bg-color-black h-100"
                        [placeholder]="'deepDive.ddOutcomeHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
            <div class="col-xs-6 space-separable h-100">
              <fieldset
                class="scheduler-border margin-top02em card cardExplore p-1 mb-2 bg-white h-100 deepdivePopover">
                <legend class="scheduler-border cursorArrow">{{ 'deepDive.ddPiHeader' | translate }}</legend>
                <div id="box" class="box iconRight" tabindex="0" data-trigger="focus" autocomplete="off"
                  data-html="true" role="button" data-toggle="popover" data-placement="left"
                  [title]="'deepDive.ddPiHeaderTip' | translate">
                </div>
                <div class="control-group fieldset-text-box-height paddingtop7px">
                  <div class="row strict h-100">
                    <div class="col-xs-12 h-100">
                      <textarea id="pi" rows="1" [ngClass]="{ dis:!selectedEntity.eID}" [(ngModel)]="selectedEntity.pIssues"
                        (focusout)="updateEntityDetails('pi')"
                        class=" form-control transparent square-edge bg-color-black h-100"
                        [placeholder]="'deepDive.ddPiHeaderPlaceholder'|translate"></textarea>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
        <div ng-attr-id="mapsTab" *ngIf="currentTab == 'maps'" class="tab-pane fade active in h-100">
          <div class="row strict h-90 card bg-white">
            <div class="row strict">
              <div class="col-xs-2 space-separable">
                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        {{ 'deepDive.usedByButtonHeading' | translate }} {{ 'deepDive.personaButton' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <input class="form-control transparent landscape-input-field" id="personatextarea" rows="1"
                        [placeholder]="'landscape.personaAdd'|translate" (keyup.enter)="addPersona()" autosize="true"
                        ngDefaultControl [(ngModel)]="newPersona" style="background-color : lightyellow !important;">
                    </li>
                    <li class="row strict" *ngFor="let p of modelData.persona">
                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                        <div style="text-align: center;">
                          <input class="cursorPointer" (click)="mapEutToPerson(p.pType,$event.target.checked)"
                            [checked]="isChecked(p.pType)" type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item cursorArrow">
                        <span class="marginleft3px ">{{p.pName}}</span>
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
              <div class="col-xs-2 space-separable">
                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        {{ 'deepDive.toSatisfyButtonHeading' | translate }} {{ 'deepDive.attButton' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>

                  </button>
                  <ul class="dropdown-menu">
                    <li class="row strict" *ngFor="let a of config.listOfAttributesUpdated">
                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1">
                        <div style="text-align: center;">
                          <input class="marginleft3px cursorPointer"
                            (click)="mapEutToAtt(a.symbol,$event.target.checked)" [checked]="isCheckedAtt(a)"
                            type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1"></div>
                      <div class="col-xs-10 col-sm-10 col-md-10 col-lg-11 col-xl-11 dropdown-item">
                        <span class="marginleft3px cursorArrow">{{a.name+" ("+a.symbol+")"}}</span>
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
              <div class="col-xs-2 space-separable">
                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-block btn-sm no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        {{ 'deepDive.interactsButtonHeading' | translate }} {{ 'deepDive.entityShortFe' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-right w-300">
                    <li *ngIf="(modelData.listOfEUTs|landscaperEntity:{eType:'TF'}:filterTypeCount) == 0">
                      <div class="alert alert-warning">
                        <strong>{{ 'emptyEntitiesErrors.Fe' | translate }}</strong>
                      </div>
                    </li>
                    <li class="row strict" *ngFor="let eut of modelData.listOfEUTs">
                      <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 col-xl-1" *ngIf="eut.eType == 'TF'">
                        <div style="text-align: center;" *ngIf="eut.eID != selectedEntity.eID">
                          <input class="cursorPointer" (click)="mapEutToEut(eut.eID,$event.target.checked)"
                            [checked]="isCheckedInter(eut)" type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 dropdown-item cursorArrow"
                        *ngIf="eut.eType == 'TF'">
                        {{this.getModuleName(eut)}} | {{eut.eName}}
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
              <div class="col-xs-2 space-separable">

                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button
                    class="btn btn-default btn-sm btn-block no-padding dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-7 span-on-button cursorArrow">
                        <span *ngIf="selectedEUT == 'UR' || selectedEUT == 'BF'">{{ 'deepDive.interactsButtonHeading' |
                          translate }}</span>
                        <span *ngIf="selectedEUT == 'TF' || selectedEUT == ''">{{ 'deepDive.usedByButtonHeading' |
                          translate }}</span>
                        {{ 'deepDive.entityShortUr' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>


                    </div>


                  </button>
                  <ul class="dropdown-menu dropdown-menu-right w-300">
                    <li *ngIf="(modelData.listOfEUTs|landscaperEntity:{eType:'UR'}:filterTypeCount) == 0">
                      <div class="alert alert-warning">
                        <strong>{{ 'emptyEntitiesErrors.Ur' | translate }}</strong>
                      </div>
                    </li>
                    <li class="row strict" *ngFor="let eut of modelData.listOfEUTs">
                      <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 col-xl-1" *ngIf="eut.eType == 'UR'">
                        <div style="text-align: center;" *ngIf="eut.eID != selectedEntity.eID">
                          <input class="cursorPointer" [checked]="isCheckedInter(eut)"
                            (click)="mapEutToEut(eut.eID,$event.target.checked)" type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 dropdown-item cursorArrow"
                        *ngIf="eut.eType == 'UR'">
                        {{this.getModuleName(eut)}} | {{eut.eName}}
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
              <div class="col-xs-2 space-separable">

                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        <span *ngIf="selectedEUT == 'BF'">{{ 'deepDive.interactsButtonHeading' | translate }}</span>
                        <span *ngIf="selectedEUT == 'TF' || selectedEUT == 'UR' || selectedEUT == ''">{{
                          'deepDive.usedByButtonHeading' | translate }}</span>
                        {{ 'deepDive.entityShortBf' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>

                  <ul class="dropdown-menu dropdown-menu-right w-300">
                    <li *ngIf="(modelData.listOfEUTs|landscaperEntity:{eType:'BF'}:filterTypeCount) == 0">
                      <div class="alert alert-warning">
                        <strong>{{ 'emptyEntitiesErrors.Bf' | translate }}</strong>
                      </div>
                    </li>
                    <li class="row strict" *ngFor="let eut of modelData.listOfEUTs">
                      <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 col-xl-1" *ngIf="eut.eType == 'BF'">
                        <div style="text-align: center;" *ngIf="eut.eID != selectedEntity.eID">
                          <input class="cursorPointer" [checked]="isCheckedInter(eut)"
                            (click)="mapEutToEut(eut.eID,$event.target.checked)" type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 dropdown-item cursorArrow"
                        *ngIf="eut.eType == 'BF'">
                        {{this.getModuleName(eut)}} | {{eut.eName}}
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
              <div class="col-xs-2 space-separable">

                <div class="dropdown" [ngClass]="{ dis:entityName == ''}">
                  <button class="btn btn-default btn-sm btn-block dropdown-toggle paddingtop3px paddingbottom3px"
                    type="button" data-toggle="dropdown">
                    <div class="row strict">
                      <div class="col-xs-8 span-on-button">
                        <span *ngIf="selectedEUT == 'XX'">{{ 'deepDive.interactsButtonHeading' | translate }}</span>
                        <span *ngIf="selectedEUT == 'TF' || selectedEUT == 'UR' || selectedEUT == 'BF'">{{
                          'deepDive.usedByButtonHeading' | translate }}</span>
                        {{ 'deepDive.entityShortXx' | translate }}
                      </div>
                      <div class="col-xs-2 pull-right">
                        <span class="caret"></span>
                      </div>
                    </div>
                  </button>

                  <ul class="dropdown-menu dropdown-menu-right w-300">
                    <li *ngIf="(modelData.listOfEUTs|landscaperEntity:{eType:'XX'}:filterTypeCount) == 0">
                      <div class="alert alert-warning">
                        <strong>{{ 'emptyEntitiesErrors.Xx' | translate }}</strong>
                      </div>
                    </li>
                    <li class="row strict" *ngFor="let eut of modelData.listOfEUTs">
                      <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 col-xl-1" *ngIf="eut.eType == 'XX'">
                        <div style="text-align: center;" *ngIf="eut.eID != selectedEntity.eID">
                          <input class="cursorPointer" [checked]="isCheckedInter(eut)"
                            (click)="mapEutToEut(eut.eID,$event.target.checked)" type="checkbox">
                        </div>
                      </div>
                      <div class="col-xs-10 col-sm-10 col-md-11 col-lg-11 col-xl-11 dropdown-item cursorArrow"
                        *ngIf="eut.eType == 'XX'">
                        {{this.getModuleName(eut)}} | {{eut.eName}}
                      </div>
                    </li>
                  </ul>
                </div>

              </div>
            </div>
            <div class="row strict deep-dive-fieldset-height">
              <div class="col-xs-12 h-100">
                <textarea class="form-control square-edge bg-color-black disabledFieldDD h-100" [(ngModel)]="mapText"
                  rows="8" disabled></textarea>
              </div>
            </div>
          </div>
        </div>
        <!-- //othertwo tabs content -->
        <!-- </div> -->
      </div>
      <!-- </div> -->
      <!-- //tabs content -->
    </div>
  </div>
  <!-- Section footer start -->
  <div class="headerBackground card p-1 mt-2 tool-footer-height">
    <div class='row pb-0 pt-0'>
      <div id="deepdiveTip" class="carousel slide" data-ride="carousel" data-interval="false">
        <!-- Wrapper for slides -->
        <div class="carousel-inner text-color-yellow">
          <div class="row item active text-color-yellow">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #1 : {{'deepDive.tip1' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #2 : {{'deepDive.tip2' | translate}}
            </div>
          </div>
          <div class="row item">
            <div class="col-xs-12 align_center carousel-tip-align cursorArrow">
              Tip #3 : {{'deepDive.tip3' | translate}}
            </div>
          </div>
        </div>
        <!-- Left and right controls -->
        <a class="left carousel-control carousel-tip-align display-flex" data-target="#deepdiveTip" data-slide="prev">
          <span>
            <fa-icon class="fas" [icon]="faChevronLeft"></fa-icon>
          </span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control carousel-tip-align display-flex" data-target="#deepdiveTip" data-slide="next">
          <span>
            <fa-icon class="fas" [icon]="faChevronRight"></fa-icon>
          </span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
  <!-- Section footer end -->
  <!-- The persona or entity duplicate error message modal -->
  <div class="modal fade" id="duplicateErrorMessagePopupModel" data-backdrop="">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content">
          <!-- Modal body -->
          <div class="modal-body">
            <div class="row pb-0">
              <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
              <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
              </div>
              <div class="col col-12 col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{duplicateEntity}}</label>
                </div>
                <div class="form-element text-align-center">
                  <label class="form-label marginbottom6px">{{errorMessage}}</label>
                </div>
                <div class="form-element text-align-center">
                  <button type="button" id="popupOkbutton"
                    class="btn btn-secondary modalActionBtn orgUserListOkbtn pr-0 pl-0" data-dismiss="modal">{{ 'ok' |
                    translate }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Test type description respective to entity -->
<div class="modal fade" id="testTypeDescModal" data-backdrop="">
  <div class="vertical-alignment-helper">
    <div class="modal-dialog vertical-align-center">
      <div class="modal-content">
        <!-- Modal body -->
        <div class="modal-body">
          <div class="row pb-0">
            <div class="col col-11 col-md-11 col-lg-11 col-sm-11 col-xs-11"></div>
            <div class="col col-1 col-md-1 col-lg-1 col-sm-1 col-xs-1 popupCloseBtn">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="col col-9 col-md-9 col-lg-9 col-sm-9 col-xs-9">
              <div class="form-element mb-0">
                <h3 for="lastname" class="form-label marginbottom6px displayNone">{{selectedTestType.symbol}}</h3>
                <div class="form-element-input">
                  <input type="text" class="form-input-feild input-sm menuItemsClrBlack" rows="2" value=""
                    [(ngModel)]="selectedTestType.desc" [placeholder]="'entityTest.testTypeDesc'|translate" required>
                </div>
              </div>
            </div>
            <div class="col col-3 col-md-3 col-lg-3 col-sm-3 col-xs-3">
              <div class="form-element">
                <div class="form-element-input inviteFormElement">
                  <button type="button" class="btn btn-secondary userInvitetoOrgBtn actionbutton pl-0 pr-0"
                    (click)="updateTestTypeDesc()">Save</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
  <!-- Youtube video Modal -->
  <div class="modal fade bd-example-modal-lg" id="ytVideoLinkDD" tabindex="-1" role="dialog"
    aria-labelledby="ytVideoLinkDD" aria-hidden="true">
    <div class="vertical-alignment-helper">
      <div class="modal-dialog vertical-align-center">
        <div class="modal-content ytVideoLink">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" (click)="terminateVideo()"
              aria-hidden="true">&times;</button>
            <h4 class="modal-title cursorArrow" id="myModalLabel">{{'youtubeVideoTitle.deepdiver' | translate}}</h4>
          </div>
          <!-- Modal body -->
          <div class="modal-body">
            <iframe width="100%" height="100%" class="youtubeVideo" id="DdVideoLink" frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>